import { useConfigurationContext } from '../../context/configurationContext'
import type { TemplateVersionInfo } from '../../types/templateModel'
import { NODE_COLLAPSED_SPACING_VERTICAL } from '../inheritanceHierarchy/constants'
import type { ChildProps } from '../versionedTimeline/VersionedArrowsGroup'
import { TemplateVersionsLine } from './TemplateVersionsLine'

export const TemplateVersionsLines = ({
  versions,
  lineStartDate,
  lineEndDate,
  lineLength,
  nodeHeight,
}: ChildProps<TemplateVersionInfo>) => {
  const { viewAt } = useConfigurationContext()

  return (
    <>
      {versions.map((template, index) => (
        <TemplateVersionsLine
          // It's important for the viewAt data to be part of the key since we need
          // a new version line to be rendered when the date changes, such that active and
          // previous versions can be reported for the view at date inside the TemplateVersionLine
          // useEffect hooks.
          key={`${template.identifier}-${viewAt}`}
          top={
            index * (nodeHeight + NODE_COLLAPSED_SPACING_VERTICAL) +
            nodeHeight / 2
          }
          lengthInPixels={lineLength}
          startDate={lineStartDate}
          endDate={lineEndDate}
          templateId={template.identifier}
        />
      ))}
    </>
  )
}
